import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { AuthService } from 'src/app/shared/services/auth.service';
import { Router } from '@angular/router';
import { CommonBookingService } from '../common-booking.service';
import { DropdownItem } from 'mis-crystal-design-system/dropdown';
import { FormControl } from '@angular/forms';
import { countries } from "countries-list";
import { BookingsViewService } from '../../bookings-view/bookings-view.service';
import { MyBookingsService } from '../../my-bookings/my-bookings.service';
import { CreateBookingService } from '../../create-booking/create-booking.service';

@Component({
  selector: 'app-booking-action',
  templateUrl: './booking-action.component.html',
  styleUrls: ['./booking-action.component.scss']
})
export class BookingActionComponent implements OnInit {

  public isGarageMappingVisible: boolean;
  public isSendCommVisible: boolean;
  public isGeoCodeVisible: boolean;
  public cancelBookingInfo: any;
  public showCancelConfirmDialog = false;
  public showEditBookingError = false;
  public isTrackingVisible: boolean;
  public isViewInvoiceVisible = false;
  public showUpdateInvoiceStatusError = false;
  public showUpdateInvoiceStatusSuccess = false;
  public updateMessage: any;
  public showAllCabs = false;

  isAssignCab = false;

  @Input() booking: any;

  @Input() miscelleneousConfig;
  @Input() config: any;
  @Input() editCutOffDetails: any;
  @Input() cancelCutOffDetails: any;
  @Input() bookingActionsConfigObj: any;
  @Input() bookingActionConfig: any;
  @Input() cancelPopupConfig: any;
  @Input() bookingActionBtnConfigObj: any;
  @Input() vendors: any;
  @Input() vendorSelectConfigObj: any;
  @Input() selectedBookings: any;
  @Input() unsortedData: any;
  @Input() cabAllocationConfigObj: any;
  @Input() vendorCabSelectFormGroup: any;
  @Input() tabularConfigObj: any;
  @Input() cabFormControl: FormControl;
  @Input() cabOptionsFormControlValues: any;
  @Input() cabAllocationConfig: any;
  @Input() elementType: any;
  @Input() isNonCompliantVisible;
  @Input() isNonCompliantSelectable;
  @Input() showAvailableCabsConfig;
  @Input() commonService;
  @Input() driverForm;
  @Input() driverList;

  @Output() handleBookingsUpdateCallback = new EventEmitter();
  @Output() cabSelectValidationsCallback = new EventEmitter();
  @Output() selectedBookingsVendorValuesReset = new EventEmitter();
  @Output() toggleAddCabCallback = new EventEmitter();
  @Output() isPopupOpen = new EventEmitter<boolean>();
  @Output() assignIndividual = new EventEmitter<boolean>();
  @Output() handleBookingsUpdateIndividualCallback = new EventEmitter<any>();
  @Output() getselectedCab = new EventEmitter<any>();
  @Output() getselectedDriver = new EventEmitter<any>();
  @Output() vendorCabMap = new EventEmitter<any>();
  @Output() driverChangeCallBack = new EventEmitter<any>();
  @Output() cancelVendorCabUpdateCallBack = new EventEmitter<any>();


  @Output() showBookingHistoryCallback = new EventEmitter();
  @Output() toggleLoadingCallBack = new EventEmitter();
  @Output() getDetailsCallback = new EventEmitter();
  @Output() showCancelBookingErrorCallback = new EventEmitter();
  @Output() showCancelBookingSuccessCallback = new EventEmitter();
  @Output() toggleAutoReload = new EventEmitter();
  @Output() showSuccessToast = new EventEmitter();
  @Output() virtualCabDriverDetails = new EventEmitter();
  @Output() clearAssignModalValues = new EventEmitter();
  @Output() showMarshallAssignmentToast = new EventEmitter();
  showWarning: boolean;
  getSelectedCabGuid: any;
  public vendorFormControl = new FormControl();
  cabs = [];
  allCabs = [];
  drivers = [];
  vendorGuid: any;
  vendorCabMaps = {};
  assignDriverToVirtualCabPopup = false;
  driverDetails = {
    driverName: '',
    driverPhone: '',
    driverCabNum: '',
    phoneCode: '91'
  };
  phonenumber = new FormControl();
  countryCodeList = [];
  enableBtn = false;
  showMappedVirtualCab = false;
  addVirtualCabModal = false;
  dropdownData: DropdownItem[];
  selectedCountryCode = { label: ' + 91 ', value: '91' };
  showVirtualCabDriverName = false;
  successBtn = 'successBtn';
  disableVendorDropdown = false;
  showRemoveCabModal = false;
  showVendorChangeDialog = false;
  vendorChangeCall = false;
  preSelectedVendor = '';
  showDocumentModal = false;
  documentList: any = [];
  showAssignMarshallPopup = false;
  enableOnMarshallSelection = true;
  showUnavailableWarning = false;
  marshallList: any[] = [];
  officeList: any[] = [];
  preponeTripSheetInHours: any;
  cancelDialog = false;
  constructor(private authService: AuthService, private router: Router,
              private commonBookingService: CommonBookingService, private createBookingService: CreateBookingService,
              private myBookingService: MyBookingsService, private bookingsViewService: BookingsViewService) { }

  marshallData: DropdownItem[] = [];
  officeData: DropdownItem[] = [];

  cabConfig = {
    displayName: "Cab Assign"
  };
  driverConfig = {
    displayName: "Driver Assign"
  };

  selectedItem: DropdownItem = { label: "", value: "" };
  selectedMarshall: DropdownItem = { label: "", value: "", icon: '' };
  selectedOffice: DropdownItem = { label: "", value: "" };
  postMarshallData: any = {};
  showMarshallWarningPopup = false;
  availableMarshallIcon = 'assets/ic-ui-seperator- green.svg';
  unavailableMarshallIcon = 'assets/ic-ui-seperator-red.svg';
  reAssigningMarshall = false;
  reAssignPopup = false;
  deleteMarshallModal = false;
  reasonText: string;
  isOpen: boolean = false;

  logSelect(e: DropdownItem) {
    this.selectedItem = e;
  }
  ngOnInit() {
        if (this.booking.cab && this.booking.cab.vendor?.guid) {
       this.setCab( this.booking.cab.vendor.guid);
    }

        this.dropdownData = Object.values(countries).map((item: any) => ({
      label: `+ ${item.phone} ${item.name}`,
      value: item.phone
    }));
  }

  setCab(vGuid){
    this.preSelectedVendor = vGuid;
    this.vendorGuid = vGuid;

  }

  cancelBooking(bookingId: any, reason: string) {
    const body = {
      modifierGuid: this.authService.user.employeeGuid,
      modifierBuid: this.authService.user.buId,
      bookingId,
      reason,
    };
    const requestBody = [];
    requestBody.push(body);
    this.commonBookingService.cancelBooking(requestBody).subscribe((response) => {
      if (this.showCancelBookingSuccessCallback) {
        this.showCancelBookingSuccessCallback.emit();
      }
      this.showCancelConfirmDialog = false;
    }, (error) => {
      if (this.showCancelBookingErrorCallback) {
        this.showCancelBookingErrorCallback.emit(error);
      }
    });
  }

  handleStatusUpdate(data: any) {
    if (this.handleBookingsUpdateCallback) {
      this.handleBookingsUpdateCallback.emit(data);
    }
  }

  handleCancelBooking(reason: string) {
    if (this.commonBookingService.isBookingCancelDisabled(this.booking, this.cancelCutOffDetails) && this.cancelBookingInfo.bookingId) {
      if (this.toggleLoadingCallBack) {
        this.toggleLoadingCallBack.emit(true);
      }
      this.cancelBooking(this.cancelBookingInfo.bookingId, reason);
    }
  }

  handleEditBooking(data: any) {
    if (this.commonBookingService.isBookingEditDisabled(data.booking, this.editCutOffDetails)) {
      this.router.navigate(['bookings/edit'], { queryParams: { bookingId: data.booking.bookingId } });
    } else {
      this.showEditBookingError = true;
    }
  }

  toggleCancelConfirmDialog(data: any) {
    this.showCancelConfirmDialog = true;
    this.cancelBookingInfo = data.booking;
  }

  dismissCancelBookingDialog() {
    this.showCancelConfirmDialog = false;
    this.cancelBookingInfo = null;
  }

  hideEditBookingError() {
    this.showEditBookingError = false;
  }

  showBookingHistory() {
    if (this.showBookingHistoryCallback) {
      this.showBookingHistoryCallback.emit({ bookingId: this.booking.bookingId });
    }
  }
  AssignCabModel(booking) {
    this.isAssignCab = !this.isAssignCab;
    this.cancelVendorCabUpdateCallBack.emit(booking);

  }
  toggleGarageMapping() {
    if (this.booking.vendor) {
      this.isGarageMappingVisible = !this.isGarageMappingVisible;
      const pauseAutoReload = this.isGarageMappingVisible ? true : false;
      this.handleAutoReload(pauseAutoReload);
    } else {
      this.showWarning = true;
    }
  }

  toggleSendComm() {
    this.isSendCommVisible = !this.isSendCommVisible;
    const pauseAutoReload = this.isSendCommVisible ? true : false;
    this.handleAutoReload(pauseAutoReload);
  }

  toggleGeoCode() {
    this.isGeoCodeVisible = !this.isGeoCodeVisible;
    const pauseAutoReload = this.isGeoCodeVisible ? true : false;
    this.handleAutoReload(pauseAutoReload);
  }

  toggleTracking() {
    this.isTrackingVisible = !this.isTrackingVisible;
    const pauseAutoReload = this.isTrackingVisible ? true : false;
    this.handleAutoReload(pauseAutoReload);
  }

  toggleViewInvoice() {
    this.isViewInvoiceVisible = !this.isViewInvoiceVisible;
    if (this.isViewInvoiceVisible && this.toggleLoadingCallBack) {
      // this.toggleLoadingCallBack.emit(true);
    }
    const pauseAutoReload = this.isViewInvoiceVisible ? true : false;
    this.handleAutoReload(pauseAutoReload);
  }

  handleAutoReload(pause: boolean) {
    if (this.toggleAutoReload) {
      this.toggleAutoReload.emit(pause);
    }
  }

  hideStatusError() {
    this.showUpdateInvoiceStatusError = false;
    this.showWarning = false;
  }

  toggleSuccessToast() {
    this.showUpdateInvoiceStatusSuccess = false;
  }

  showSuccessErrorAction(data: any) {
    this.updateMessage = data.message;
    if (data.actionSuccessful) {
      this.showUpdateInvoiceStatusSuccess = true;
    } else {
      this.showUpdateInvoiceStatusError = true;
    }
    this.isViewInvoiceVisible = false;
    if (this.toggleLoadingCallBack) {
      this.toggleLoadingCallBack.emit(false);
    }
  }

  handleToggleLoadingOnViewInvoice(value: boolean) {
    if (this.toggleLoadingCallBack) {
      this.toggleLoadingCallBack.emit(value);
    }
  }

  handleSuccessToastToggle(message: string) {
    if (this.showSuccessToast) {
      this.showSuccessToast.emit(message);
    }
  }

  getBookingStatusObj(booking) {
    return {
      paymentStatus: booking.paymentStatus,
      tripStatus: booking.tripStatus,
      managerStatus: booking.managerStatus,
      vendorStatus: booking.vendorStatus,
      cabAllocStatus: booking.cabAllocStatus,
      tripBillingStatus: booking.tripBillingStatus
    };
  }

  handleDuplicateBooking() {
    this.router.navigate(['bookings/create'], { queryParams: { bookingId: this.booking.bookingId } });
  }

  onVendorValueSelected(vendorguId: string) {
    if (this.preSelectedVendor != '' && this.preSelectedVendor != vendorguId) {
      this.vendorChangeCall = true;
    }
    this.vendorGuid = vendorguId;
    const vendor = this.unsortedData.vehicleData.filter(function(el) {
      return el.vendor.guid === vendorguId;
    });
    this.cabs = vendor[0].cab;
  }

  rejectVendorChange() {
    this.showVendorChangeDialog = false;
    this.vendorChangeCall = false;

  }
  approveVendorChange() {
    if (this.handleBookingsUpdateIndividualCallback){
      this.handleBookingsUpdateIndividualCallback.emit({ action: 'vendor-cab-update', cabs: this.cabs });
      this.getselectedCab.emit(this.cabs);
      this.vendorFormControl.reset();
      this.showVendorChangeDialog = false;
    }
  }

  onShowAllCabCheck(e){
    e.value ? this.disableVendorDropdown = true : this.disableVendorDropdown = false;
    this.showAllCabs = e.value;
    this.unsortedData.vehicleData.forEach(ele => {
      ele.cab.forEach(cab =>
        this.allCabs.push(cab));
    });
  }
  getCabsValue(cab: any) {
    return cab.guId;
  }

  getCabsLabel(cab: any) {
    return cab.registration;
  }

  getDriverName(driver) {
    if (driver && driver?.phoneNumbers?.length > 0 && driver?.phoneNumbers[0]) {
      return `${driver['name']} (${driver?.phoneNumbers[0]})`;
    }
  }


  getDriverValue(driver) {
    if (driver) {
      return driver['guid'];
    }
  }

  assign() {
    if (this.booking?.vendor?.guid) {
      this.onVendorValueSelected(this.booking.vendor.guid);
    }

    this.assignIndividual.emit(this.booking.bookingId);
  }

  handleSubmitVendorUpdate() {
    if (this.handleBookingsUpdateIndividualCallback && this.vendorChangeCall) {
      this.isAssignCab = false;
      this.showVendorChangeDialog = true;
    }
    else if (this.handleBookingsUpdateIndividualCallback && !this.showMappedVirtualCab) {
      this.getselectedCab.emit(this.cabs);
      this.handleBookingsUpdateIndividualCallback.emit({ action: 'vendor-cab-update', cabs: this.cabs });
      this.vendorFormControl.reset();
    }
   else if (this.showMappedVirtualCab) {
      this.isPopupOpen.emit(true);
      this.virtualCabDriverDetails.emit(this.driverDetails);
    }
  }

  selectCab(event) {
    const vendorGuid = this.vendorGuid;
    this.getSelectedCabGuid = event;
    if (this.commonService.workflowConfig.multiDriverPropertyEnabled) {
      const vendor = this.unsortedData.vehicleData.filter(function(el) {
        return el.vendor.guid === vendorGuid;
      });
      if (vendor.length > 0) {
        this.driverList = vendor[0].driver;
      }
    } else {
      const driver = this.cabs.filter(function(el) {
        return el.guId === event;
      });
      this.driverList = driver[0]?.drivers;
    }
    this.getselectedDriver.emit(this.driverList);
    // this.formVendorCabMap();
  }

  assignDriverToVirtualCab(event) {
    this.assignDriverToVirtualCabPopup = event;
    if (event) { this.isAssignCab = false; }
  }

  submitVirtualCabDriver() {
    this.assignDriverToVirtualCabPopup = false;
    this.isAssignCab = true;
    this.showMappedVirtualCab = true;
    this.showVirtualCabDriverName = true;
  }

  clearUpdate() {
    this.enableBtn = false;
    this.driverDetails.driverCabNum = '';
    this.driverDetails.driverName = '';
    this.driverDetails.driverPhone = '';
    this.driverDetails.phoneCode = '91';
    this.selectedCountryCode = {
      label: '+ 91',
      value: "91"
    };
    this.phonenumber.reset();
  }

  checkInput() {
    if (this.driverDetails.driverCabNum != '' &&
      this.driverDetails.driverName != '') { this.enableBtn = true; }
  }

  showAddVirtualCabModal() {
    this.addVirtualCabModal = true;
    this.isAssignCab = false;
  }

  countryCodeSelection(event) {
    const code = event.label.split(" ");
    this.selectedCountryCode = {
      label: `+ ${code[1]}`,
      value: event.value
    };
  }
  formVendorCabMap() {
    for (const vendor of this.vendors) {
      this.vendorCabMaps[vendor.guid] = [];
      for (const cab of this.cabs) {
        if (cab.vendor.guid === vendor.guid) {
          this.vendorCabMaps[vendor.guid].push(cab);
        }
      }
    }
    this.vendorCabMap.emit(this.vendorCabMaps);
    if (this.selectedBookingsVendorValuesReset) {
      this.selectedBookingsVendorValuesReset.emit(this.vendorGuid);
    }
  }
  getDriverPhone(e){
    this.driverDetails.phoneCode = this.selectedCountryCode.value;
    this.phonenumber.setValue(e.target.value);
    this.driverDetails.driverPhone = this.phonenumber.value;
  }

  removeCab() {
    this.bookingsViewService.removecabRank(this.booking.bookingId);
    this.cabFormControl.reset();
    if (this.cabSelectValidationsCallback) {
      this.cabSelectValidationsCallback.emit(this.booking);
      this.handleSubmitVendorUpdate();
    }
  }
  selectedDriver(value, booking) {
    const data = {
      value,
      booking
    };
    this.driverChangeCallBack.emit(data);
  }

  clearAssignModalUpdate(booking) {
    this.bookingsViewService.clearUpdate.next(true);
  }

  cancelVendorCabUpdate(booking: any) {
    this.AssignCabModel(booking);
    this.cancelVendorCabUpdateCallBack.emit(booking);
  }

  viewDocuments(){
    this.showDocumentModal = true;
    this.myBookingService.fetchDocuments(this.booking.bookingId).subscribe(res => {
      this.documentList = Object.entries(res).slice(1).map(([filename, filesize]) => ({ filename, filesize }));
    });
  }

  showAssignMarshallPopupFn(booking){
     this.showAssignMarshallPopup = true;
     if (booking.stops){
      booking.stops[0].riders.forEach((rider) => {
        if (rider.riderType == 'MARSHAL'){
          this.selectedMarshall = { label: rider.name, value: rider.emplGuid, icon: '' };
          this.selectedOffice = { label: booking.stops[0].address, value: rider.officeGuid };
          this.reAssigningMarshall = true;
          this.enableOnMarshallSelection = false;
        }
      });
    }

     this.createBookingService.preponeTripSheetInHours.subscribe(res => {
      this.preponeTripSheetInHours = res;
       });
  }
  removeMarshall(bookingID) {
    this.bookingsViewService.deleteMarshal(bookingID).subscribe(res => {
    this.showMarshallAssignmentToast.next(res);
    this.deleteMarshallModal = false;
});

  }

  applyMarshall() {
    this.showAssignMarshallPopup = false;
    if (this.reAssigningMarshall) { this.reAssignPopup = true; }
   else {
    this.selectedMarshall.icon == this.availableMarshallIcon ?   this.showMarshallWarningPopup = true  :  this.showUnavailableWarning = true;
   }
  }

  assignMarshall(bookingId) {
    this.showMarshallWarningPopup = false;
    this.reAssignPopup = false;
    this.selectedMarshall = { label: "", value: "", icon: '' };
    this.selectedOffice = { label: "", value: "" };
    // post call
    this.bookingsViewService.postMarshal(this.postMarshallData, bookingId).subscribe(res => this.showMarshallAssignmentToast.next(res));
    this.reAssigningMarshall = false;

  }

  getMarshallOffice(bookingId) {
    this.bookingsViewService.fetchMarshals(bookingId).subscribe(res => {
      this.marshallList = res;
      this.marshallData =
      this.marshallList.map((element: { name: any; guid: any; available: any }) => (
        {
          label: element.name,
          value: element.guid,
          icon: element.available ? this.availableMarshallIcon : this.unavailableMarshallIcon
        }
      ));
    });

    this.bookingsViewService.fetchMarshalOffice().subscribe(res => {
      this.officeList = res;
      this.officeData = this.officeList.map((element: { address: any; guid: any }) => ({
        label: element.address,
        value: element.guid,
      }));
    });
  }

  getMarshall(event) {
    this.selectedMarshall = event;
    if (this.reAssigningMarshall) {
      this.selectedOffice = { label: "", value: "" };
    }
    const marshall = this.marshallList.filter((item) => {
      return item.guid == event.value;
    });
    this.postMarshallData.marshal = marshall[0];
  }

  getOffice(event) {
    this.selectedOffice = event;
    this.enableOnMarshallSelection = false;
    const office = this.officeList.filter((item) => {
      return item.guid == event.value;
    });
    this.postMarshallData.office = office[0];
  }
}
